import { render } from "./sidebar_layout.vue?vue&type=template&id=2e171446"
import script from "./sidebar_layout.vue?vue&type=script&lang=js"
export * from "./sidebar_layout.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__